import React, { useEffect } from 'react';
import { Skeleton } from 'antd';

import { Refetch } from '@/components/ui/Refetch';
import { useBeraReportV2 } from '@/context/BeraReportV2';

import { Footer } from './Footer';
import { Banners } from './Banners';
import { Playback } from './Playback';
import { VideoStatus } from './VideoStatus';
import { EvaluationArea } from './EvaluationArea';
import { IdentifiedStretches } from './IdentifiedStretches';
import { Container } from './styles';

interface ContentProps {
	autoOpenResult?: boolean;
	onPrevious: () => void;
	onAutoOpenResult?: () => void;
}

export function Content({ autoOpenResult = false, onPrevious, onAutoOpenResult }: Readonly<ContentProps>): JSX.Element {
	const {
		jobSummary,
		allReports,
		isVideoProcessing,
		isVideoCorrupted,
		isLoading,
		isError,
		onRefetch
	} = useBeraReportV2();

	const areAllReportsEvaluated = allReports.length > 0 && allReports.every((report) => !!report.is_evaluated);

	const isAlreadyFinished = !!jobSummary.show_bera_result && areAllReportsEvaluated;

	const hasVideoStatus = isVideoProcessing || isVideoCorrupted;

	const hasReports = allReports.length > 0;

	useEffect(() => {
		if (!autoOpenResult || isLoading || !isAlreadyFinished) {
			return;
		}

		onAutoOpenResult?.();
	}, [autoOpenResult, isLoading, isAlreadyFinished]);

	if (isLoading) {
		return (
			<Container>
				<Skeleton active />
			</Container>
		);
	}

	if (isError) {
		return (
			<Container>
				<Refetch onClick={onRefetch} />
			</Container>
		);
	}

	return (
		<Container>
			{hasVideoStatus && <VideoStatus />}
			<Playback>
				<Banners />
			</Playback>
			<IdentifiedStretches />
			{hasReports && <EvaluationArea />}
			<Footer onPrevious={onPrevious} />
		</Container>
	);
}
